import styled from 'styled-components';

export const MiceDropDownContainer = styled.div(
	({ theme: { down, breakpoints } }) => `
				.custom-styles-select__control {
					min-height: 30px;
					border: 0;
					height: auto;
					padding: 0;
					&:hover, &:focus {
						border: 0;
					}
 				}
				.custom-styles-select__indicator {
					color: rgba(241, 117, 67, 1);
					&:hover {
						color: rgba(241, 117, 67, 0.7);
					}
				}
				
				.custom-styles-select__value-container {
					font-size: 22px;
					color: #000000;
					font-weight: 900;
					.custom-styles-select__single-value {
						font-size: 22px;
						color: #000000;
						font-weight: 900;
				
					}
				}
				.fld-label {
			    font-size: 16px;
					margin-bottom: 10px;
					color: #000;
					font-weight: 400;
				}
        ${down(breakpoints.md)} {
						flex-wrap: nowrap;
						overflow-x: scroll;
        }
    `
);
